import { createFileRoute } from '@tanstack/react-router'

import { QuietHoursPage } from '#/modules/communication/quiet-hours-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/quiet-hours')({
  component: QuietHoursPage,
  validateSearch: validateListSearch,
})
